import React, { useState, useContext, useEffect, useRef } from "react";

import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/mayaLogo.png";

import { AuthContext } from "../../Context/UserContext";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";
import profile from "../../assets/images/user.png";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CiCirclePlus } from "react-icons/ci";
import { FaEyeSlash, FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";
import { FiEdit2 } from "react-icons/fi";
import axiosClient from "../../axios-client";
import { TbArrowBackUp } from "react-icons/tb";

function NewProfile() {
    const { user } = useContext(AuthContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [profileData, setProfileData] = useState({}); // To store the profile details before adding the password
    const [ErrorMessage, setErrorMessage] = useState("");
    const [profilePic, setProfilePic] = useState("");
    const [newProfielPicURL, setNewProfielPicURL] = useState("");
    const [newProfielPic, setNewProfielPic] = useState("");
    const [userName, setUserName] = useState("");
    const [filters, setFilters] = useState({
        NUDITÉ: true,
        "SCÈNE INTIME": true,
        "VIOLENCE PHYSIQUE": false,
        "VULGARITÉ SONORE": true,
        "VULGARITÉ VISUELLE": true,
    });
    const [checked, setChecked] = useState(false);

    const handleChange = (event) => {
        setChecked(event.target.checked);
        setPassword('')
        setConfirmPassword('')
        setErrorMessage('')
    };
    const navigate = useNavigate();
    const inputRef = useRef(null);

    const handleFileChange = (event) => {
        const fileObj = event.target.files[0];
        setNewProfielPic(fileObj);
        setNewProfielPicURL(URL.createObjectURL(fileObj));
    };

    const toggleFilter = (filter) => {
        setFilters((prev) => ({ ...prev, [filter]: !prev[filter] }));
    };

    // const handleSubmit = async (event) => {
    //     event.preventDefault();

    //     try {
    //         // Create FormData object
    //         const formData = new FormData();

    //         formData.append("user", user.id);
    //         formData.append("username", userName);
    //         formData.append("filters", JSON.stringify(filters));
    //         if (newProfielPic) {
    //             formData.append("avatar", newProfielPic);
    //         }

    //         // Make the API request to create a new profile
    //         const response = await axiosClient.post(
    //             "/profiles/create/",
    //             formData,
    //             {
    //                 headers: {
    //                     "Content-Type": "multipart/form-data",
    //                 },
    //             }
    //         );

    //         navigate("/profile");
    //     } catch (err) {
    //         console.error("Error creating profile", err);
    //     }
    // };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Save profile data to state
        setProfileData({
            user: user.id,
            username: userName,
            filters,
            avatar: newProfielPic || null,
        });

        // Open the password modal
        setIsModalOpen(true);
    };

    const handleNewPasswordSubmit = async () => {

        if (checked && password !== confirmPassword) {
            setErrorMessage("Les mots de passe ne correspondent pas.");
            return;
        }
        if (checked && (!password || !confirmPassword)) {
            setErrorMessage("Veuiller remplire les champs de mot de passe");
            return;
        }

        try {
            // Create FormData object
            const formData = new FormData();
            // formData.append("user", profileData.user);
            // formData.append("username", profileData.username);
            // formData.append("filters", JSON.stringify(profileData.filters));
            // if (profileData.avatar) {
            //     formData.append("avatar", profileData.avatar);
            // }

            formData.append("user", user.id);
            formData.append("username", userName);
            formData.append("filters", JSON.stringify(filters));
            if (newProfielPic) {
                const originalFileName = newProfielPic.name;
                const fileExtension = originalFileName.split('.').pop();
                const newFileName = `${originalFileName.replace(`.${fileExtension}`, '')}_${user.id}_${Date.now()}.${fileExtension}`;
                const renamedAvatar = new File([newProfielPic], newFileName, { type: newProfielPic.type });
    
                formData.append("avatar", renamedAvatar);
            }
            // if (newProfielPic) {
            //     formData.append("avatar", newProfielPic);
            // }
            if(checked && password) {
                formData.append("password", password);
            }
            // Make the API request to create a new profile
            const response = await axiosClient.post("/profiles/create/", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            // Navigate to the profile page
            navigate("/profile");
        } catch (err) {
            // console.error("Error creating profile", err);
            setErrorMessage("Une erreur s'est produite lors de la création du profil.");
        }
    };

    return (
        <section
            className="py-10 px-3  min-h-[100vh] flex-col flex items-center justify-center relative"  // Ensures the section takes the full height and centers content
            style={{
                background: `url(${WelcomePageBanner})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment: "fixed",
            }}
        >
            <Link
                onClick={() => navigate(-1)}
                className="absolute top-2 left-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
                title="Se déconnecter"
            >
                <TbArrowBackUp size={"26px"} className="text-orange-500" />
            </Link>
            <div className="pb-5 flex justify-center items-center ">
                <img
                    className="h-10 cursor-pointer w-18"
                    src={logo}
                    alt="MAYAPLUS"
                />
            </div>
            <div className="w-full bg-white/5 max-w-sm backdrop-blur-md p-5 md:p-10 rounded-lg">

                <h1 className=" text-center text-xl text-white  mb-4 md:mb-8">
                    Ajouter votre profil
                </h1>

                <div className="  flex flex-col gap-5 justify-between items-center cursor-pointer mb-4 md:mb-8">
                    <div className="relative">
                        <img
                            className="border-2 object-cover border-orange-400 w-24 h-24 rounded-full cursor-pointer"
                            src={newProfielPicURL || profile}
                            alt="Profile"
                        />
                        <input
                            type="file"
                            ref={inputRef}
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                        <div className="absolute top-1 right-0 bg-white rounded-full p-1">
                            <FiEdit2 onClick={() => inputRef.current.click()} className="text-orange-500 cursor-pointer" />
                        </div>
                    </div>

                    <input
                        type="text"
                        name="nom"
                        id="nom"
                        className="bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg w-full focus:ring-primary-600 focus:border-primary-600 block p-3.5 dark:placeholder-gray dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"
                        placeholder="Nom complet"
                        required=""
                        onChange={(e) => setUserName(e.target.value)}
                    />



                </div>
                <div className="flex flex-col gap-1 justify-start items-start cursor-pointer">
                    <h4 className="text-center text-md text-white mb-2">Vos filtres :</h4>
                    {Object.entries(filters).map(([label, isActive]) => (
                        <div
                            key={label}
                            className="flex justify-between items-center w-full max-w-sm gap-10 cursor-pointer"
                            onClick={() => toggleFilter(label)}
                        >
                            <span className={`text-md font-semibold ${isActive ? "line-through text-gray-400" : "text-white"}`}>
                                {label}
                            </span>
                            {label === "VULGARITÉ SONORE" ? (
                                isActive ? (
                                    <FaMicrophoneSlash className="h-5 w-5 text-gray-400" />
                                ) : (
                                    <FaMicrophone className="h-5 w-5 text-white" />
                                )
                            ) : isActive ? (
                                <FaEyeSlash className="h-5 w-5 text-gray-400" />
                            ) : (
                                <FaEye className="h-5 w-5 text-white" />
                            )}
                        </div>
                    ))}
                </div>
                <div className="flex items-center mt-5">
                    <input
                        id="checked-checkbox"
                        type="checkbox"
                        checked={checked}
                        onChange={handleChange}
                        className="w-4 h-4 text-orange-600 bg-gray-600 border-gray-300 rounded-sm  "
                    />
                    <label
                        htmlFor="checked-checkbox"
                        className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                    >
                        verrouiller votre profil ?
                    </label>
                </div>
                {checked &&
                    <div className="mt-5 flex flex-col gap-2">
                        {ErrorMessage && (
                            <h1 className="flex text-sm text-white p-3 mb-3 bg-red-500 rounded">
                                {ErrorMessage}
                            </h1>
                        )}
                        <input
                            type="password"
                            placeholder="Mot de passe"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg w-full focus:ring-primary-600 focus:border-primary-100 block p-3.5 placeholder:text-gray"
                            />
                        <input
                            type="password"
                            placeholder="Confirmer votre mot de passe"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="bg-white/10 backdrop-blur text-white sm:text-sm rounded-lg w-full focus:ring-primary-600 focus:border-primary-100 block p-3.5 placeholder:text-gray"
                            />
                        
                    </div>}

            </div>
            <div className="w-[100%] mt-5 flex items-center justify-center">
                <Link >
                    {!userName.trim() ?
                        <button
                            style={{
                                background: "linear-gradient(to right, #eb6820, #fd9358)",
                                opacity: 0.5,
                            }}
                            className=" lg:w-[100%] px-14 py-3 mt-3 font-medium text-white rounded-md md:text-md flex items-center justify-center"
                            disabled
                        >
                            Ajouter le profil
                        </button>
                        :
                        <button
                            onClick={handleNewPasswordSubmit}
                            style={{
                                background: "linear-gradient(to right, #eb6820, #fd9358)",
                            }}
                            className=" lg:w-[100%] px-14 py-3 mt-3 font-medium text-white rounded-md md:text-md flex items-center justify-center"
                        >
                            Ajouter le profil
                        </button>
                    }



                </Link>
            </div>
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">

                    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                        <h2 className="text-lg font-semibold mb-4">Ajouter un mot de passe de profil</h2>
                        {ErrorMessage && (
                            <h1 className="flex text-sm text-white p-3 mb-3 bg-red-500 rounded">
                                {ErrorMessage}
                            </h1>
                        )}
                        <input
                            type="password"
                            placeholder="Mot de passe"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
                        />
                        <input
                            type="password"
                            placeholder="Confirmer votre mot de passe"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
                        />
                        <div className="flex justify-end gap-3">
                            <button
                                onClick={() => setIsModalOpen(false)}
                                className="px-4 py-2 bg-gray-500 text-white rounded-md"
                            >
                                Annuler
                            </button>
                            <button
                                disabled={!password || !confirmPassword}
                                onClick={handleNewPasswordSubmit}
                                className="px-4 py-2 bg-orange-500 text-white rounded-md"
                            >
                                Continuer
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </section>
    );
}

export default NewProfile;
